import React from 'react';
import GroupRoundedIcon from '@mui/icons-material/GroupRounded';
import EmojiEventsRoundedIcon from '@mui/icons-material/EmojiEventsRounded';
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded';
import CenterFocusStrongRoundedIcon from '@mui/icons-material/CenterFocusStrongRounded';
import './about.css'

const About = () => {
    return (
        <div>
          {/* Top Banner */}
          <div className="hero-banner">
            <div className="container">
              <div className="row">
                <div className="col-12 text-center">
                  <h1 className="hero-title mb-0">About Us</h1>
                </div>
              </div>
            </div>
          </div>
    
          {/* Company Overview Section */}
          <div className="section-padding">
            <div className="container">
              <div className="row">
                <div className="col-12 text-center mb-5">
                  <h2 className="display-4 fw-bold text-dark mb-4">Our Story</h2>
                  <div className="row justify-content-center">
                    <div className="col-lg-10">
                      <p className="fs-5 text-muted mb-4 lh-lg">
                      Achievers iQ is a next-generation EdTech platform founded in January 2024 by visionary entrepreneur Irshad Choudhary. 
                      Built on the belief that quality education should be accessible, engaging, and tailored to every learner’s unique journey, 
                      Achievers iQ empowers students across all age groups and curricula to unlock their full potential
                      </p>
                      <p className="fs-5 text-muted mb-5 lh-lg">
                      We are more than just a learning platform , we are a student-first institute designed to build not just knowledge, 
                      but confidence, clarity, and character.<br/><br/>
                        <b>Join us on a journey where achievement isn’t just a goal,  it’s a mindset.</b>

                      </p>
                    </div>
                  </div>
                  
                  {/* Stats Section */}
                  <div className="row g-4 mt-4">
                    <div className="col-lg-3 col-md-6">
                      <div className="stats-card h-100">
                        <div className="icon-wrapper icon-blue mx-auto">
                          <GroupRoundedIcon size={24} />
                        </div>
                        <div className="display-5 fw-bold text-dark mb-2">2500+</div>
                        <div className="text-uppercase text-muted small fw-semibold tracking-wide">Happy Students</div>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                      <div className="stats-card h-100">
                        <div className="icon-wrapper icon-green mx-auto">
                          <EmojiEventsRoundedIcon	 size={24} />
                        </div>
                        <div className="display-5 fw-bold text-dark mb-2">90%+</div>
                        <div className="text-uppercase text-muted small fw-semibold">Average Percentile</div>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                      <div className="stats-card h-100">
                        <div className="icon-wrapper icon-purple mx-auto">
                          <CenterFocusStrongRoundedIcon size={24} />
                        </div>
                        <div className="display-5 fw-bold text-dark mb-2">3000+</div>
                        <div className="text-uppercase text-muted small fw-semibold">Classes</div>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                      <div className="stats-card h-100">
                        <div className="icon-wrapper icon-red mx-auto">
                          <FavoriteRoundedIcon	 size={24} />
                        </div>
                        <div className="display-5 fw-bold text-dark mb-2">200+</div>
                        <div className="text-uppercase text-muted small fw-semibold">Experienced Teachers</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
    
          {/* Founder Section - Text Left, Image Right */}
          <div className="bg-white section-padding">
            <div className="container">
              <div className="row align-items-center g-5">
                <div className="col-lg-6">
                  <div className="pe-lg-4">
                    <span className="badge bg-primary bg-opacity-10 text-primary px-3 py-2 rounded-pill mb-3 fw-semibold">
                      Director
                    </span>
                    <h3 className="display-5 fw-bold text-dark mb-4">Irshad Choudhary</h3>
                    <p className="fs-5 text-muted mb-4 lh-lg">
                    With a strong business acumen and deep understanding of the education landscape, 
                    Irshad has led the charge in redefining how academic and skill-based coaching is delivered. 
                    His passion lies in creating personalized learning experiences that combine proven teaching methodologies with  technology.
                    </p>
                    {/* <p className="fs-5 text-muted mb-4 lh-lg">
                      Sarah's leadership philosophy centers around innovation, collaboration, and student success. 
                      Under her guidance, the company has grown from a two-person team to a global organization 
                      with offices in San Francisco, London, and Singapore.
                    </p> */}
                    {/* <div className="mt-4">
                      <span className="badge-custom">MIT Graduate</span>
                      <span className="badge-custom">15+ Years Experience</span>
                      <span className="badge-custom">Tech Visionary</span>
                    </div> */}
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="image-wrapper founder-bg">
                    <img 
                      src="images/irshad.jpg" 
                      alt="Sarah Johnson - Founder & CEO"
                      className="founder-image"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
    
          {/* Co-founder Section - Image Left, Text Right */}
          <div className="bg-light section-padding">
            <div className="container">
              <div className="row align-items-center g-5">
                <div className="col-lg-6 order-lg-1">
                  <div className="image-wrapper cofounder-bg">
                    <img 
                      src="/images/aryan.jpg" 
                      alt="Aaryan Daterao"
                      className="founder-image"
                    />
                  </div>
                </div>
                <div className="col-lg-6 order-lg-2">
                  <div className="ps-lg-4">
                    <span className="badge bg-success bg-opacity-10 text-success px-3 py-2 rounded-pill mb-3 fw-semibold">
                      Co-founder
                    </span>
                    <h3 className="display-5 fw-bold text-dark mb-4">Aaryan Daterao</h3>
                    <p className="fs-5 text-muted mb-4 lh-lg">
                    Aaryan Daterao, a current IBDP1 student at GEMS Modern Academy, is a visionary co-founder of AchieversIQ, an emerging EdTech company since May-2024. 
                    With a strong technical acumen, Aaryan is dedicated to leveraging cutting-edge solutions to revolutionize the educational landscape. 
                    His passion lies in enhancing the learning experience for students across all grades, constantly exploring ways to integrate the latest technologies for impactful outcomes. 
                    Aaryan is deeply invested in optimizing educational processes and firmly believes in empowering students with the right technology for efficient and engaging learning.
                    </p>
                    {/* <p className="fs-5 text-muted mb-4 lh-lg">
                      As CTO, Michael has been instrumental in developing our proprietary AI-driven solutions and 
                      establishing our reputation for delivering cutting-edge technology. His commitment to technical 
                      excellence and continuous innovation drives our engineering team to push boundaries and 
                      create solutions that exceed client expectations.
                    </p> */}
                    {/* <div className="mt-4">
                      <span className="badge-custom">Stanford PhD</span>
                      <span className="badge-custom">AI Expert</span>
                      <span className="badge-custom">Cloud Architect</span>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
    
          {/* Mission & Values Section */}
          <div className="bg-white section-padding">
  <div className="container">
    <div className="row">
      <div className="col-12 text-center mb-5">
        <h2 className="display-4 fw-bold text-dark mb-4">Our Mission</h2>
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <p className="fs-5 text-muted mb-5 lh-lg">
              To transform learning through innovative, accessible, and engaging educational technologies that empower students, educators, and institutions to thrive in a knowledge-driven world.
            </p>
          </div>
        </div>

        <div className="row g-4">
          <div className="col-lg-4 col-md-6">
            <div className="mission-card">
              <h4 className="h5 fw-bold text-dark mb-3">Innovation in Learning</h4>
              <p className="text-muted mb-0">
                We harness the power of cutting-edge technology to create dynamic, personalized learning experiences that inspire and educate.
              </p>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="mission-card">
              <h4 className="h5 fw-bold text-dark mb-3">Commitment to Quality</h4>
              <p className="text-muted mb-0">
                From interactive platforms to curriculum design, we prioritize excellence to deliver impactful and meaningful educational outcomes.
              </p>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="mission-card">
              <h4 className="h5 fw-bold text-dark mb-3">Empowering Partnerships</h4>
              <p className="text-muted mb-0">
                We collaborate with educators, institutions, and communities to build inclusive, scalable solutions that make learning accessible for all.
              </p>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

        </div>
      );
}

export default About;